export const TABLE_PARTS = [
  'container',
  'header',
  'title',
  'footer',
  'htmlTable',
  'tr',
  'thead',
  'th',
  'tbody',
  'td',
  'tdInner',
  'tfoot',
] as const;
